










































import AbpBase from "@/lib/abpbase";
import formGenerator from "../formGenerator/index.vue";
import { demo1, demo2, demo3, demo4 } from "./formjson";
import util from "@/lib/util";
import { Component } from "vue-property-decorator";

@Component({
  components: { formGenerator }
})
export default class extends AbpBase {
  // 表单数据信息
  eleList: any = null;
  // 是否弹框
  jsonDialog = false;
  // 弹框标题
  dialogTitle = "表单数据";
  // 弹框内容
  jsonmsg = "";

  // 展示表单
  showForm(index) {
    if (index === 1) {
      this.eleList = demo1;
    }
    if (index === 2) {
      this.eleList = demo2;
    }
    if (index === 3) {
      this.eleList = demo3;
    }
    if (index === 4) {
      this.eleList = demo4;
    }
  }

  getFormValue() {
    // 调用表单生成器的getFormVal方法获取表单数据
    (this.$refs.Cform as any).getFormVal().then(data => {
      this.dialogTitle = "表单数据";
      this.jsonDialog = true;
      this.jsonmsg = JSON.stringify(data, null, 1);
    });
  }

  getFormJson() {
    this.dialogTitle = "表单JSON";
    this.jsonDialog = true;
    let formjson = util.copy(this.eleList);
    this.jsonmsg = JSON.stringify(formjson, null, 1);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/formDemos/index.vue